<template>
  <div class="pc">
    <section class="pc1 pc_com">
      <section class="bottons">
        <span @click="download"> </span>
      </section>
      <div class="list">
        <img src="~@/assets/phone.png" alt="" />
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mark: 0,
      SElit: ""
    };
  },
  methods: {
  download() {
      let apk = this.$apk;
      if (apk && apk != '') {
        window.location.href = this.$apk;
      }
    }
  }
};
</script>

<style scoped lang="less">
.pc {
  width: 80%;
  height: 80%;
  padding-top: 1%;
  box-sizing: border-box;
  overflow: hidden;
  .pc_com {
    width: 100%;
    height: 100%;
    position: relative;
    .list {
      width: 100%;
      height: 100%;
      //overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .list_ani-enter-active {
      transition: all 1s;
    }
    .list_ani-leave-active {
      transition: all 1s;
    }
    .list_ani-enter,
    .list_ani-leave-to {
      transform: translateX(300px);
    }
    .bottons {
      width: 2.45rem;
      height: 1.6rem;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      left: 47%;
      top: 50%;
      span {
        display: block;
        width: 2.45rem;
        height: 0.6rem;
      }
      span:first-child {
        background: url("~@/assets/btn_android_normal.png");
        background-size: 100% 100%;
        cursor: pointer;
      }
      span:first-child:hover {
        background: url("~@/assets/btn_android_cover.png");
        background-size: 100% 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue